import type {
  TUserDto,
  TUserResponse
} from '@/AdminPanel/pages/Users/types/user.types';
import { ApiConnector } from '@/api/api.connector';

class UsersApi extends ApiConnector {
  getAdminAllUsers(
    limit?: number,
    offset?: number,
    searchTerm?: string,
    role?: string,
    isActive?: string
  ): Promise<{
    total: number;
    data: TUserResponse[];
  }> {
    return this.call({
      path: 'admin/users',
      params: {
        limit,
        offset,
        searchTerm,
        role,
        isActive
      }
    });
  }

  getAdminUserById(uuid: string): Promise<TUserResponse> {
    return this.call({
      path: `admin/users/${uuid}`
    });
  }

  createAdminUser(data: TUserDto) {
    return this.call({
      path: 'admin/users',
      method: 'post',
      body: data
    });
  }

  updateAdminUser(userId: string, data: Partial<TUserDto>) {
    return this.call({
      path: `admin/users/${userId}`,
      method: 'patch',
      body: data
    });
  }
}

export const usersApi = new UsersApi();
